import '!wix-tpa-style-loader?mode=inline!sass-loader?{"includePaths": [".", "node_modules"]}!../../assets/styles/injected-style-fullscreen.global.scss';
import '../../assets/styles/injected-style-fullscreen.global.scss';
import './index-fullscreen.global.scss';
import 'html2canvas'



// WEBPACK FOOTER //
// ./apps/fullscreen/externals-fullscreen.js